import { IMAGE } from '../elements/assets'

export const AGENDA_SCHEDULE = `
...on agendaSchedule_Entry {
  id
  typeHandle

  headingAdvanced {
    html
  }

  agendaSlots {
    ... on agendaSlot_Entry {
      id
      time: title

      agendaSessions {
        id
        time
        title
        subTitle: text
        description
        tags {
          id
          title
        }

        speaker {
          id
          title
          description
          ${ IMAGE }
        }
      }
    }
  }
}
`